import InputBoolean from './InputBoolean';

export default InputBoolean;
